<template>
  <div>
    <apexchart
      :height="height"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series:{
      type:Array,
      required:true
    },
    categories: {
      type:Array,
      required:true
    },
    height: {
      type: Number,
      default: 250
    },
    title:{
      type: String,
      required: true
    },
    yTitle:{
      type: String
    },
    xTitle:{
      type: String
    },
    horizontal:{
      type:Boolean,
      default: false
    },
    customOptions:{
      type: Object,
      default(){
        return {

        }
      }
    }

  },
  computed: {
    chartOptions() {
      let options = {                
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5]
        },
        title: {
          text: this.title,
          align: "center"
        },
        legend: {
          tooltipHoverFormatter: function(val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },        
        tooltip: {
          y: [
            {
              title: {
                formatter: function(val) {
                  return val;
                }
              }
            }
          ]
        },
        grid: {
          borderColor: "#f1f1f1"
        },
        chart: {
          id: "vuechart-horizontal-chart",
          toolbar:{
            show:false
          },
           zoom:{
             enabled:false
           }
        },
        xaxis: {
          title:{
            text: this.xTitle
          },
          categories: this.categories,
          labels: {
            datetimeFormatter: {
              year: 'yyyy',
              month: 'MMM \'yy',
              day: 'MMM dd',
              hour: 'HH:mm'
            }
          }
        },
        yaxis:{
          title:{
            text: this.yTitle
          }
        },
        plotOptions:{
          bar:{
            borderRadius: 4,
            horizontal: this.horizontal
          }
        }
      }
      for (const [key, value] of Object.entries(this.customOptions)) {
       options[key] = value
      }
      return options
    }
  }
};
</script>